import { animate, state, style, transition, trigger } from '@angular/animations';
import { HttpHeaders } from '@angular/common/http';
import { Component, HostListener, Input, OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserTaskNotificationVO } from 'app/models/psp-notification';
import { Subscription } from 'rxjs';
import { ActivityListService } from '../../Services/activity-list.service';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { AppSettings } from '../../app-settings';
import { EventService } from "../../Services/event.service";
import { CementingStatusService } from '../../Services/cementing-status.service';
import { JourneyMilestoneService } from '../../Services/journey-milestone.service';
import { CementingStatus, cementingDifficultyOfTopicName, findCategory } from '../../models/cementing-status';
import { deriveJourneyHeader } from '../../models/cementing-messages';
@Component({
  selector: "app-activity-list",
  templateUrl: "./activity-list.component.html",
  styleUrls: ["./activity-list.component.css"],
  animations: [
    trigger("coursePopUpInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.3s", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.3s", style({ opacity: 0 })),
      ]),
    ]),
    trigger("levelCollapsedExpanded", [
      state("expanded", style({ width: "100%" })),
      state("collapsed", style({ width: "68%" })),
      transition("expanded <=> collapsed", animate("300ms linear")),
    ])
  ],
})
export class ActivityListComponent implements OnChanges, OnInit {
  levelState: any = "collapsed";
  courseName: string;
  sub: any;
  data: any;
  searchQuery: string;
  lensImage: any;
  background: any;
  bulletImage: any;
  polyImage: any;
  searchModeOn: Boolean;
  statusModeOn: Boolean;
  lockImage: any;
  closeUserPop: any;
  closeUserPopGray: any;
  blueInfoIcon: any;
  whiteInfoIcon: any;
  expandIcon: any;
  upgradedActIcon: any;
  upgradedActHollowIcon: any;
  activiyLoadImg: string =
    AppSettings.cdnUrl + "assets/images/activity-loading.gif";
  isActivityLoaded: boolean = false;
  editMenuOptions: any;
  statusImage: {
    Attempted: "assets/images/completed.png";
    Revision: "assets/images/revision.png";
  };
  filterCount: number = 0;
  @Input("pageName")
  pageName: string;
  options = [
    { display: "Not Started", state: "NEW" },
    { display: "In Progress", state: "INPROGRESS" },
    { display: "Completed", state: "COMPLETED" },
    { display: "Revision", state: "REVISION" },
  ];
  activeOptions = [];
  screenSize: number;
  item = 1;
  popLockeImg: any;
  closePopCourse: any;
  statusFilterBy: string = "userState";
  coursePopUpFlag: boolean = false;
  openTwoModulesFlag: boolean = false;
  isFreeTrialUser: boolean = false;
  userInfo: any;
  lockActivityData: any = {};
  quizTypeSubscription: Subscription;
  quizType: String = "";
  section: string = "";
  activeFrontEndPageName: string = "";
  archivedFrontEndPageName: string = "";
  archivedMessage: string = "";
  upgradedActivityURL: string = "";
  showArchivedPopUp: boolean = false;
  archivedMessageOpen: boolean = true;
  pageId: any;
  archivedMessageLSItemName = "archivedMessageCollapseConfig";
  showLS360Tile: boolean = false;
  paceViewLogoIconURL: string = "";
  paceLink: string = "";
  paceEnabled: boolean = true;
  showPaceTimeView = false;
  showPaceView: boolean = false;
  skipRightArrowIconURL: string = "";
  highlightActivityIconURL: string = "";
  paceActivity = {};
  viewName: string = "module";
  journeyCourseId: any;
  showNoCourseFoundAlert:boolean;
  pspCourseName: string = '';
  expiredSubscription: boolean = false;
  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.screenSize = event.target.innerWidth;
  }

  executionTrackerSync = false;

  userTaskNotificationVO: UserTaskNotificationVO = null;

  /** Cementing stages of this course's subject (module view), null when the subject has none. */
  cementingStatus: CementingStatus | null = null;
  cementingSubject: string = '';
  private cementingChanges: Subscription;

  constructor(
    private activityListService: ActivityListService,
    private router: Router,
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private httpClientService: HttpClientService, private eventService: EventService,
    private cementingStatusService: CementingStatusService,
    private journeyMilestoneService: JourneyMilestoneService) {
    this.lensImage = AppSettings.cdnUrl + "assets/images/search_icon.png";
    this.background = "url(" + this.lensImage + ") no-repeat scroll 7px 7px";
    this.bulletImage = AppSettings.cdnUrl + "assets/images/bullet.png";
    this.polyImage = AppSettings.cdnUrl + "assets/images/polygon.png";
    this.popLockeImg = AppSettings.cdnUrl + "assets/images/course_locked.gif";
    this.closePopCourse =
      AppSettings.cdnUrl + "assets/images/closePopcourse.png";
    this.lockImage = AppSettings.cdnUrl + "assets/images/locked_en_act.png";
    this.closeUserPop = AppSettings.cdnUrl + "assets/images/user_pop_exit.png";
    this.closeUserPopGray =
      AppSettings.cdnUrl + "assets/images/cancel-icon-gray.png";
    this.blueInfoIcon = AppSettings.cdnUrl + "assets/images/blue_info_icon.png";
    this.whiteInfoIcon =
      AppSettings.cdnUrl + "assets/images/white_info_icon.png";
    this.upgradedActIcon =
      AppSettings.cdnUrl + "assets/images/upgraded_act_icon.png";
    this.upgradedActHollowIcon =
      AppSettings.cdnUrl + "assets/images/upgraded_act_icon_hollow.png";
    this.expandIcon =
      AppSettings.cdnUrl + "assets/images/up_arrow_more_less.png";
    this.paceViewLogoIconURL =
      AppSettings.cdnUrl + "assets/images/pace_view_logo.png";
    this.skipRightArrowIconURL =
      AppSettings.cdnUrl + "assets/images/skip_right_arrow_icon.png";
    this.highlightActivityIconURL =
      AppSettings.cdnUrl + "assets/images/highlight_activity_icon.png";
    this.statusModeOn = false;
    this.editMenuOptions = this.activityListService.activityStatus;
    this.quizTypeSubscription = this.sessionService.sharedQuizType.subscribe(
      (data) => {
        this.quizType = data;
        // console.log(this.quizType);
      }
    );
    this.sessionService.getPaceEnabled$.subscribe((data) => {
      if (typeof data == "boolean") {
        this.paceEnabled = data;
        this.showPaceTimeView = true;
      }
    });
    // A choice recorded in a cementing panel refreshes the whole subject status (both modules).
    this.cementingChanges = this.cementingStatusService.statusChanges$.subscribe(status => {
      if (!this.cementingSubject || status.subject !== this.cementingSubject.toUpperCase()) { return; }
      this.applyCementingStatus(status);
    });
  }

  /** new / started / completed from an LMS module state such as STARTED_NORMALLY. */
  private static statusKeyOfLmsState(state: string): 'new' | 'started' | 'completed' {
    const lms = (state || '').toUpperCase();
    return lms.indexOf('COMPLETED') >= 0 ? 'completed' : lms === 'NEW' || lms === '' ? 'new' : 'started';
  }

  /**
   * The status pill of a cementing topic: the module state from the Scholaranium
   * status API once it is in, else the LMS execution-tracker state the course
   * payload carries (topic.cementingModule.levelStatus).
   */
  private labelCementingTopic(topic) {
    if (topic.cementingCategory) {
      const header = deriveJourneyHeader(topic.cementingCategory);
      topic.cementingStatusKey = header.status;
      topic.cementingStatusLabel = header.statusLabel;
      return;
    }
    const key = ActivityListComponent.statusKeyOfLmsState(topic.cementingModule ? topic.cementingModule.levelStatus : '');
    topic.cementingStatusKey = key;
    topic.cementingStatusLabel = key === 'completed' ? 'Completed' : key === 'started' ? 'In progress' : 'Not started';
  }

  /** Hands the subject status to every cementing topic. */
  private applyCementingStatus(status: CementingStatus | null) {
    this.cementingStatus = status;
    const topics: any[] = Array.isArray(this.data) ? this.data : (this.data && this.data.topics) || [];
    topics.forEach(topic => {
      if (!topic.cementingDifficulty) { return; }
      topic.cementingCategory = findCategory(status, topic.cementingDifficulty);
      this.labelCementingTopic(topic);
    });
  }

  /**
   * Module view: the Cementing Medium / Hard topics get the cementing quizzes
   * panel. The course payload marks them with the journey module behind them
   * (topic.cementingModule: id, CM / CH, difficulty, LMS state); a topic named
   * like "Stage 2 - Medium Cementing" without that block (older backend) is
   * recognised by its name. One Scholaranium status call feeds both stages.
   */
  setupCementingTopics(data) {
    this.cementingStatus = null;
    // ActivityListService.getData() hands back the topics array itself.
    const topics: any[] = Array.isArray(data) ? data : (data && data.topics) || [];
    let hasCementingTopic = false;
    topics.forEach(topic => {
      const module = topic.cementingModule;
      topic.cementingDifficulty = module && module.difficulty ? module.difficulty : cementingDifficultyOfTopicName(topic.name);
      topic.cementingCategory = null;
      if (topic.cementingDifficulty) { this.labelCementingTopic(topic); }
      hasCementingTopic = hasCementingTopic || !!topic.cementingDifficulty;
    });
    if (!hasCementingTopic || !this.journeyCourseId || this.journeyCourseId === -1) {
      return;
    }
    this.journeyMilestoneService.getJourneyIdentity(this.journeyCourseId).subscribe(identity => {
      if (!identity || !identity.journeyName) { return; }
      this.cementingSubject = identity.journeyName;
      if (!this.section && identity.section) { this.section = identity.section; }
      this.cementingStatusService.getStatus(this.cementingSubject).subscribe(status => this.applyCementingStatus(status));
    }, () => {});
  }

  /** "Move to Hard Cementing" / "Go to Medium Cementing": expands that module's topic. */
  openCementingTopic(difficulty: string) {
    const topics: any[] = Array.isArray(this.data) ? this.data : (this.data && this.data.topics) || [];
    topics.forEach(topic => {
      if (topic.cementingDifficulty) { topic.isVisible = topic.cementingDifficulty === difficulty; }
    });
  }

  statusChange(optionObject, activity) {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl +
          "/api/activity/" +
          activity.id +
          "/page/" +
          this.pageName +
          "/state/" +
          optionObject.state,
        headers
      )
      .subscribe((data) => {
        //activity.statusImage = optionObject.Image; activity.activityStatus = this.editMenuOptions[optionObject.state];
        optionObject.state = optionObject.state.toUpperCase();
        this.sessionService.updateDashboard(1);
        this.getData();
      });
  }

  ngOnInit() {
    this.getUserInfo();

    // this.getData();
    // this.getPaceData();
    this.sub = this.route.params.subscribe((params) => {
      if (params["view"]) {
        this.viewName = params["view"];
      }
    });
    this.sessionService.levelCollapsed.subscribe((state) => {
      this.levelState = state;
      if(this.screenSize < 992) this.levelState = "collapsed";
    });

    this.sessionService.updatePageName(this.pageName);
  }

  getUserInfo() {
    this.userInfo = this.sessionService.getUserInfo$.subscribe((data) => {
      if (data != "") {
        this.isFreeTrialUser = data.courseEnrollments.freeTrial;
      }
    });
  }
  getGradeClass(grade: string): string {
    if (!grade) return '';
    
    switch (grade.toUpperCase()) {
      case 'A+': return 'grade-a-plus';
      case 'A': return 'grade-a';
      case 'A-': return 'grade-a-minus';
      case 'B+': return 'grade-b-plus';
      case 'B': return 'grade-b';
      case 'C': return 'grade-c';
      case 'NR*': return 'grade-nr';
      default: return '';
    }
  }

  ngOnChanges() {
    this.getDailyHours();
    this.getData();
    this.getPaceData();
    this.filterCount = 0;
    this.screenSize = window.innerWidth;
  }
  toggleStatus() {
    this.statusModeOn = !this.statusModeOn;
  }
  onClickedOutside(e: Event) {
    this.statusModeOn = false;
  }
  updateCheckedOptions(option, $event) {
    if ($event.target.checked) {
      this.activeOptions.push(option.state);
      this.filterCount = this.filterCount + 1;
    } else {
      this.activeOptions.splice(this.activeOptions.indexOf(option.state), 1);
      this.filterCount = this.filterCount - 1;
    }
  }

  searchChange($event) {
    if ($event) {
      this.searchModeOn = true;
    } else {
      this.searchModeOn = false;
    }
  }

  crossClick() {
    this.searchQuery = "";
    this.searchModeOn = false;
  }

  syncEvent(e){
    this.getDailyHours();
    this.getData();
    this.getPaceData();
    this.filterCount = 0;
    this.screenSize = window.innerWidth;
  }

  getData() {
    this.isActivityLoaded = false;
    this.showNoCourseFoundAlert = false;
    this.activeFrontEndPageName = "";
    this.archivedFrontEndPageName = "";
    let headers = new HttpHeaders();
    this.httpClientService
      .get(AppSettings.restApiUrl + "/api/course/" + this.pageName, headers)
      .subscribe((data) => {
        this.showNoCourseFoundAlert = !data.success;
        if(data.success){
        this.userTaskNotificationVO = data.userTaskNotificationVO;
        this.executionTrackerSync = data.executionTrackerSync;
        this.pspCourseName = (this.userTaskNotificationVO && this.userTaskNotificationVO.completionMilestone && this.userTaskNotificationVO.completionMilestone.courseName)?this.userTaskNotificationVO.completionMilestone.courseName:null;
        this.data = data;
        this.journeyCourseId = data.journeyCourseId;
        this.section = data["section"];
        this.pageId = data.pageId;
        this.showPaceView = data.paceSystemEnabled;
        let showPaceView = this.showPaceView ? true : false;
        this.paceEnabled = showPaceView;
        this.sessionService.updatePaceEnabled(showPaceView);
        if (data.hasDeprecatedVersion || data.deprecated) {
          this.getArchivedPageLink();
        }
        this.checkAndCollapseArchivedMessage();
        this.data = this.activityListService.getData(this.data);
        this.sessionService.updateSpentTime(this.data.humanEfforts);
        this.setupCementingTopics(this.data);

        this.openTwoModulesFlag =
          this.activityListService.getRecentActivityActiveFlag();
        for (var i = 0; i < data.topics.length; i++) {

          if(data.pageId == 230){
              data.topics[i].isVisible = true;
          }else if (data.topics[i].isRecentTopic == "YES") {
            data.topics[i].isVisible = true;
          }
          for (var j = 0; j < data.topics[i].activities.length; j++) {
            data.topics[i].activities[j].isEditVisible = false;
            data.topics[i].activities[j].isEditMenuVisible = false;
          }
        }
        if (this.openTwoModulesFlag) {
          for (var i = 0; i < data.topics.length; i++) {
            data.topics[i].isVisible = true;
            if (i >= 1) {
              break;
            }
          }
        }
      }
        this.isActivityLoaded = true;
        //this.data=data;
      });
    if (window.location.href.indexOf("/your_study_plan") > -1) {
      setTimeout(() => {
        window["chmln"].show("629997e2f72fbb0010a50f5b", { open: true });
        window["chmln"].show("629dbb7c225a0e0012608533", { open: true });
        //console.log("chmln loaded");
      }, 2000);
    }
  }

  getDailyHours() {
    // let headers = new HttpHeaders();
    // this.httpClientService
    //   .get(AppSettings.restApiUrl + "/api/dashboard/" + this.pageName, headers)
    //   .subscribe((data) => {
    //     this.paceActivity["numberOfHoursPerDay"] = data.dailyStudyHours;
    //   });
    this.sessionService.dailyStudyHours$.subscribe(hours => {
      this.paceActivity["numberOfHoursPerDay"] = hours;
    })
  }

  getPaceData() {
    this.sessionService.courseCompletionTime$.subscribe((data) => {
      this.paceActivity["humanEfforts"] = data;
      this.paceActivity["timeSaving"] =
        this.paceActivity["humanEfforts"]["nonPaceHumanEfforts"] -
        this.paceActivity["humanEfforts"]["paceHumanEfforts"];
    });
  }

  hoursPerDay(value) {
    if (
      Number(value.innerText) &&
      Number(value.innerText) !== this.paceActivity["numberOfHoursPerDay"]
    ) {
      this.paceActivity["numberOfHoursPerDay"] = Number(value.innerText);
      this.updateDailyHours();
    }
  }

  updateDailyHours() {
    let dailyStudyHours = Number(this.paceActivity["numberOfHoursPerDay"]);
    const headers = new HttpHeaders();
    this.httpClientService
      .post(
        AppSettings.restApiUrl +
          "/api/user/daily-study-hours/" +
          dailyStudyHours,
        {},
        headers
      )
      .subscribe((data) => console.log(data));
  }

  getArchivedPageLink() {
    console.log("hello archived");
    this.httpClientService
      .get(
        AppSettings.restApiUrl +
          "/api/page/" +
          this.pageId +
          "/version/details",
        new HttpHeaders()
      )
      .subscribe((data) => {
        this.archivedFrontEndPageName = data["archivedFrontEndPageName"];
        this.activeFrontEndPageName = data["activeFrontEndPageName"];
      });
  }
  validateCoursePopUp(
    hasAccess: boolean,
    activityName: string,
    moduleName: string,
    courseName: string,
    activityId: number,
    activity
  ) {
    if (!hasAccess) {
      let kmProperties = {};
      kmProperties["ALA_Content"] = activityName;
      kmProperties["ALA_Module"] = moduleName;
      kmProperties["ALA_Course"] = courseName;
      this.eventService.track("Accessed Locked Activity", kmProperties);
      this.lockActivityData["coursePopUpFlag"] = true;
      this.lockActivityData["isFreeUser"] = this.isFreeTrialUser;
      document.body.classList.add("coursePopIn");
      let utm_source_name = 'blitzkrieg_activity';
      if(activity.type == 'RISE_ADOBE_CONNECT'){
        utm_source_name = 'rise_ls_file';
      }
      this.sessionService.getExpiredSubscriptionFlag.subscribe(flag => {
        if(flag){
          this.lockActivityData["upgradeURL"] = ("https://learn.e-gmat.com/products/extensions-and-upgrades?utm_source="+utm_source_name);
          // this.router.navigateByUrl("/user/extensions");
        } else {
          this.lockActivityData["upgradeURL"] = this.isFreeTrialUser ? AppSettings.publicSiteURL + '/pricing?scroll=scroll-to-buy-now' : ('https://learn.e-gmat.com/products/extensions-and-upgrades?utm_source='+utm_source_name);
        }
      });
    } else {
      if (activity.isArchived) {
        let eventName = "Click Obsolete Activity";
        let computedProperties = {
          activity_name: activityName,
          trigger_location: "activity list - course page",
        };
        this.eventService.track(eventName, computedProperties);
        // this.showArchivedPopUp=true;
        // this.archivedMessage = activity.archivedMessage.messageString;
        // this.upgradedActivityURL = activity.archivedMessage.upgradedActivityURL;
        // document.body.classList.add('coursePopIn');
        let url = "/archived/page/" + this.pageName + "/activity/" + activityId;
        this.router.navigateByUrl(url);
      }
    }
  }
  changePopUpFlag(flag: boolean) {
    this.lockActivityData.coursePopUpFlag = flag;
  }
  ngOnDestroy() {
    this.userInfo.unsubscribe();
    this.quizTypeSubscription.unsubscribe();
    if (this.cementingChanges) { this.cementingChanges.unsubscribe(); }
  }

  getUpgradeURL(activityId: number) {
    let headers = new HttpHeaders();
    this.httpClientService
      .get(
        AppSettings.restApiUrl + "/api/user/upgrade/activity/" + activityId,
        headers
      )
      .subscribe((data) => {
        this.lockActivityData["upgradeURL"] = data.upgradeURL;
      });
  }
  closeArchivedPopUp(val: string) {
    this.showArchivedPopUp = false;
    document.body.classList.remove("coursePopIn");
  }
  LoadUpgradedActivity() {
    if (this.upgradedActivityURL) {
      window.location.href = this.upgradedActivityURL;
    }
  }
  checkAndCollapseArchivedMessage() {
    let item = this.getLocalStorageItem(this.archivedMessageLSItemName);
    item = item ? item : {};
    if (item) {
      if (item[this.pageName]) {
        this.archivedMessageOpen = false;
      } else {
        item[this.pageName] = false;
      }
    } else {
      item[this.pageName] = false;
    }
    this.setLocalStorageItem(this.archivedMessageLSItemName, item);
  }

  getTotalActivities(topic) {
    if (this.paceEnabled) {
      return topic.activities.filter(
        (item) =>
          item["paceAction"] != "HIDE" && item["paceAction"] != "DEHIGHLIGHT"
      ).length;
    } else {
      return topic.activities.length;
    }
  }

  getTotalCompletedActivities(topic) {
    if (this.paceEnabled) {
      return topic.activities.filter(
        (item) =>
          item["paceAction"] != "HIDE" &&
          item["paceAction"] != "DEHIGHLIGHT" &&
          (item["userState"] == "COMPLETED_AUTO" ||
            item["userState"] == "COMPLETED_MANUAL" ||
            item["userState"] == "REVISION")
      ).length;
    } else {
      return topic.activities.filter(
        (item) =>
          item["userState"] == "COMPLETED_AUTO" ||
          item["userState"] == "COMPLETED_MANUAL" ||
          item["userState"] == "REVISION"
      ).length;
    }
  }

  getTotalCompletionPercentage(topic) {
    return (
      (this.getTotalCompletedActivities(topic) /
        this.getTotalActivities(topic)) *
      100
    );
  }

  toggleMessage() {
    let item = this.getLocalStorageItem(this.archivedMessageLSItemName);
    item = item ? item : {};
    if (this.archivedMessageOpen) {
      item[this.pageName] = true;
    } else {
      item[this.pageName] = false;
    }
    this.archivedMessageOpen = !this.archivedMessageOpen;
    this.setLocalStorageItem(this.archivedMessageLSItemName, item);
  }

  getLocalStorageItem(name) {
    return JSON.parse(localStorage.getItem(name));
  }

  setLocalStorageItem(name, value) {
    localStorage.setItem(name, JSON.stringify(value));
  }

  togglePace(event) {
    let isChecked = event.target.checked;
    this.paceEnabled = isChecked;
    this.sessionService.updatePaceEnabled(this.paceEnabled);
  }

  activityHoverHide(activity, param) {
    activity[param] = activity["clicked"] === true ? true : false;
  }
  
}
